/*
 * @Description: 省市数据本地存储
 * @Author: 肖申平
 * @Date: 2022-12-13 15:48:23
 * @LastEditors: liuzhezhe 3449223724@qq.com
 * @LastEditTime: 2024-04-23 16:38:03
 */
// 需特殊处理的市级城市(后端无区级数据返回)
export const SpecAddrLv2Data = {
  TW: '710100', // '台湾省'
  XG: '810100', // '香港特别行政区',
  AM: '820100' // '澳门特别行政区'
}

export const cityData = [
  {
    cd: '110000',
    nm: '北京市',
    nodeLvl: 1,
    children: [
      {
        cd: '110100',
        nm: '北京市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '120000',
    nm: '天津市',
    nodeLvl: 1,
    children: [
      {
        cd: '120100',
        nm: '天津市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '130000',
    nm: '河北省',
    nodeLvl: 1,
    children: [
      {
        cd: '130100',
        nm: '石家庄市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '130200',
        nm: '唐山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '130300',
        nm: '秦皇岛市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '130400',
        nm: '邯郸市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '130500',
        nm: '邢台市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '130600',
        nm: '保定市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '130700',
        nm: '张家口市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '130800',
        nm: '承德市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '130900',
        nm: '沧州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '131000',
        nm: '廊坊市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '131100',
        nm: '衡水市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '140000',
    nm: '山西省',
    nodeLvl: 1,
    children: [
      {
        cd: '140100',
        nm: '太原市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '140200',
        nm: '大同市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '140300',
        nm: '阳泉市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '140400',
        nm: '长治市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '140500',
        nm: '晋城市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '140600',
        nm: '朔州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '140700',
        nm: '晋中市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '140800',
        nm: '运城市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '140900',
        nm: '忻州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '141000',
        nm: '临汾市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '141100',
        nm: '吕梁市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '150000',
    nm: '内蒙古自治区',
    nodeLvl: 1,
    children: [
      {
        cd: '150100',
        nm: '呼和浩特市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '150200',
        nm: '包头市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '150300',
        nm: '乌海市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '150400',
        nm: '赤峰市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '150500',
        nm: '通辽市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '150600',
        nm: '鄂尔多斯市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '150700',
        nm: '呼伦贝尔市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '150800',
        nm: '巴彦淖尔市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '150900',
        nm: '乌兰察布市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '152200',
        nm: '兴安盟',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '152500',
        nm: '锡林郭勒盟',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '152900',
        nm: '阿拉善盟',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '210000',
    nm: '辽宁省',
    nodeLvl: 1,
    children: [
      {
        cd: '210100',
        nm: '沈阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '210200',
        nm: '大连市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '210300',
        nm: '鞍山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '210400',
        nm: '抚顺市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '210500',
        nm: '本溪市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '210600',
        nm: '丹东市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '210700',
        nm: '锦州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '210800',
        nm: '营口市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '210900',
        nm: '阜新市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '211000',
        nm: '辽阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '211100',
        nm: '盘锦市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '211200',
        nm: '铁岭市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '211300',
        nm: '朝阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '211400',
        nm: '葫芦岛市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '220000',
    nm: '吉林省',
    nodeLvl: 1,
    children: [
      {
        cd: '220100',
        nm: '长春市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '220200',
        nm: '吉林市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '220300',
        nm: '四平市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '220400',
        nm: '辽源市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '220500',
        nm: '通化市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '220600',
        nm: '白山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '220700',
        nm: '松原市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '220800',
        nm: '白城市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '222400',
        nm: '延边朝鲜族自治州',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '230000',
    nm: '黑龙江省',
    nodeLvl: 1,
    children: [
      {
        cd: '230100',
        nm: '哈尔滨市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '230200',
        nm: '齐齐哈尔市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '230300',
        nm: '鸡西市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '230400',
        nm: '鹤岗市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '230500',
        nm: '双鸭山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '230600',
        nm: '大庆市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '230700',
        nm: '伊春市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '230800',
        nm: '佳木斯市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '230900',
        nm: '七台河市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '231000',
        nm: '牡丹江市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '231100',
        nm: '黑河市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '231200',
        nm: '绥化市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '232700',
        nm: '大兴安岭地区',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '310000',
    nm: '上海市',
    nodeLvl: 1,
    children: [
      {
        cd: '310100',
        nm: '上海市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '320000',
    nm: '江苏省',
    nodeLvl: 1,
    children: [
      {
        cd: '320100',
        nm: '南京市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '320200',
        nm: '无锡市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '320300',
        nm: '徐州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '320400',
        nm: '常州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '320500',
        nm: '苏州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '320600',
        nm: '南通市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '320700',
        nm: '连云港市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '320800',
        nm: '淮安市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '320900',
        nm: '盐城市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '321000',
        nm: '扬州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '321100',
        nm: '镇江市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '321200',
        nm: '泰州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '321300',
        nm: '宿迁市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '330000',
    nm: '浙江省',
    nodeLvl: 1,
    children: [
      {
        cd: '330100',
        nm: '杭州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '330200',
        nm: '宁波市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '330300',
        nm: '温州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '330400',
        nm: '嘉兴市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '330500',
        nm: '湖州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '330600',
        nm: '绍兴市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '330700',
        nm: '金华市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '330800',
        nm: '衢州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '330900',
        nm: '舟山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '331000',
        nm: '台州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '331100',
        nm: '丽水市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '340000',
    nm: '安徽省',
    nodeLvl: 1,
    children: [
      {
        cd: '340100',
        nm: '合肥市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '340200',
        nm: '芜湖市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '340300',
        nm: '蚌埠市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '340400',
        nm: '淮南市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '340500',
        nm: '马鞍山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '340600',
        nm: '淮北市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '340700',
        nm: '铜陵市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '340800',
        nm: '安庆市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '341000',
        nm: '黄山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '341100',
        nm: '滁州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '341200',
        nm: '阜阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '341300',
        nm: '宿州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '341500',
        nm: '六安市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '341600',
        nm: '亳州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '341700',
        nm: '池州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '341800',
        nm: '宣城市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '350000',
    nm: '福建省',
    nodeLvl: 1,
    children: [
      {
        cd: '350100',
        nm: '福州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '350200',
        nm: '厦门市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '350300',
        nm: '莆田市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '350400',
        nm: '三明市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '350500',
        nm: '泉州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '350600',
        nm: '漳州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '350700',
        nm: '南平市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '350800',
        nm: '龙岩市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '350900',
        nm: '宁德市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '360000',
    nm: '江西省',
    nodeLvl: 1,
    children: [
      {
        cd: '360100',
        nm: '南昌市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '360200',
        nm: '景德镇市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '360300',
        nm: '萍乡市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '360400',
        nm: '九江市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '360500',
        nm: '新余市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '360600',
        nm: '鹰潭市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '360700',
        nm: '赣州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '360800',
        nm: '吉安市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '360900',
        nm: '宜春市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '361000',
        nm: '抚州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '361100',
        nm: '上饶市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '370000',
    nm: '山东省',
    nodeLvl: 1,
    children: [
      {
        cd: '370100',
        nm: '济南市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '370200',
        nm: '青岛市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '370300',
        nm: '淄博市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '370400',
        nm: '枣庄市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '370500',
        nm: '东营市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '370600',
        nm: '烟台市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '370700',
        nm: '潍坊市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '370800',
        nm: '济宁市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '370900',
        nm: '泰安市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '371000',
        nm: '威海市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '371100',
        nm: '日照市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '371300',
        nm: '临沂市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '371400',
        nm: '德州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '371500',
        nm: '聊城市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '371600',
        nm: '滨州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '371700',
        nm: '菏泽市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '410000',
    nm: '河南省',
    nodeLvl: 1,
    children: [
      {
        cd: '410100',
        nm: '郑州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '410200',
        nm: '开封市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '410300',
        nm: '洛阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '410400',
        nm: '平顶山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '410500',
        nm: '安阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '410600',
        nm: '鹤壁市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '410700',
        nm: '新乡市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '410800',
        nm: '焦作市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '410900',
        nm: '濮阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '411000',
        nm: '许昌市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '411100',
        nm: '漯河市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '411200',
        nm: '三门峡市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '411300',
        nm: '南阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '411400',
        nm: '商丘市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '411500',
        nm: '信阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '411600',
        nm: '周口市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '411700',
        nm: '驻马店市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '420000',
    nm: '湖北省',
    nodeLvl: 1,
    children: [
      {
        cd: '420100',
        nm: '武汉市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '420200',
        nm: '黄石市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '420300',
        nm: '十堰市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '420500',
        nm: '宜昌市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '420600',
        nm: '襄阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '420700',
        nm: '鄂州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '420800',
        nm: '荆门市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '420900',
        nm: '孝感市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '421000',
        nm: '荆州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '421100',
        nm: '黄冈市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '421200',
        nm: '咸宁市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '421300',
        nm: '随州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '422800',
        nm: '恩施土家族苗族自治州',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '430000',
    nm: '湖南省',
    nodeLvl: 1,
    children: [
      {
        cd: '430100',
        nm: '长沙市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '430200',
        nm: '株洲市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '430300',
        nm: '湘潭市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '430400',
        nm: '衡阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '430500',
        nm: '邵阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '430600',
        nm: '岳阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '430700',
        nm: '常德市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '430800',
        nm: '张家界市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '430900',
        nm: '益阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '431000',
        nm: '郴州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '431100',
        nm: '永州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '431200',
        nm: '怀化市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '431300',
        nm: '娄底市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '433100',
        nm: '湘西土家族苗族自治州',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '440000',
    nm: '广东省',
    nodeLvl: 1,
    children: [
      {
        cd: '440100',
        nm: '广州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '440200',
        nm: '韶关市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '440300',
        nm: '深圳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '440400',
        nm: '珠海市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '440500',
        nm: '汕头市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '440600',
        nm: '佛山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '440700',
        nm: '江门市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '440800',
        nm: '湛江市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '440900',
        nm: '茂名市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '441200',
        nm: '肇庆市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '441300',
        nm: '惠州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '441400',
        nm: '梅州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '441500',
        nm: '汕尾市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '441600',
        nm: '河源市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '441700',
        nm: '阳江市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '441800',
        nm: '清远市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '441900',
        nm: '东莞市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '442000',
        nm: '中山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '445100',
        nm: '潮州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '445200',
        nm: '揭阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '445300',
        nm: '云浮市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '450000',
    nm: '广西壮族自治区',
    nodeLvl: 1,
    children: [
      {
        cd: '450100',
        nm: '南宁市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '450200',
        nm: '柳州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '450300',
        nm: '桂林市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '450400',
        nm: '梧州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '450500',
        nm: '北海市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '450600',
        nm: '防城港市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '450700',
        nm: '钦州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '450800',
        nm: '贵港市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '450900',
        nm: '玉林市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '451000',
        nm: '百色市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '451100',
        nm: '贺州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '451200',
        nm: '河池市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '451300',
        nm: '来宾市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '451400',
        nm: '崇左市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '460000',
    nm: '海南省',
    nodeLvl: 1,
    children: [
      {
        cd: '460100',
        nm: '海口市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '460200',
        nm: '三亚市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '460300',
        nm: '三沙市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '460400',
        nm: '儋州市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '500000',
    nm: '重庆市',
    nodeLvl: 1,
    children: [
      {
        cd: '500100',
        nm: '重庆市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '510000',
    nm: '四川省',
    nodeLvl: 1,
    children: [
      {
        cd: '510100',
        nm: '成都市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '510300',
        nm: '自贡市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '510400',
        nm: '攀枝花市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '510500',
        nm: '泸州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '510600',
        nm: '德阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '510700',
        nm: '绵阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '510800',
        nm: '广元市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '510900',
        nm: '遂宁市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511000',
        nm: '内江市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511100',
        nm: '乐山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511300',
        nm: '南充市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511400',
        nm: '眉山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511500',
        nm: '宜宾市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511600',
        nm: '广安市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511700',
        nm: '达州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511800',
        nm: '雅安市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '511900',
        nm: '巴中市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '512000',
        nm: '资阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '513200',
        nm: '阿坝藏族羌族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '513300',
        nm: '甘孜藏族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '513400',
        nm: '凉山彝族自治州',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '520000',
    nm: '贵州省',
    nodeLvl: 1,
    children: [
      {
        cd: '520100',
        nm: '贵阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '520200',
        nm: '六盘水市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '520300',
        nm: '遵义市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '520400',
        nm: '安顺市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '520500',
        nm: '毕节市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '520600',
        nm: '铜仁市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '522300',
        nm: '黔西南布依族苗族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '522600',
        nm: '黔东南苗族侗族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '522700',
        nm: '黔南布依族苗族自治州',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '530000',
    nm: '云南省',
    nodeLvl: 1,
    children: [
      {
        cd: '530100',
        nm: '昆明市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '530300',
        nm: '曲靖市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '530400',
        nm: '玉溪市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '530500',
        nm: '保山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '530600',
        nm: '昭通市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '530700',
        nm: '丽江市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '530800',
        nm: '普洱市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '530900',
        nm: '临沧市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '532300',
        nm: '楚雄彝族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '532500',
        nm: '红河哈尼族彝族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '532600',
        nm: '文山壮族苗族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '532800',
        nm: '西双版纳傣族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '532900',
        nm: '大理白族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '533100',
        nm: '德宏傣族景颇族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '533300',
        nm: '怒江傈僳族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '533400',
        nm: '迪庆藏族自治州',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '540000',
    nm: '西藏自治区',
    nodeLvl: 1,
    children: [
      {
        cd: '540100',
        nm: '拉萨市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '540200',
        nm: '日喀则市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '540300',
        nm: '昌都市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '540400',
        nm: '林芝市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '540500',
        nm: '山南市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '540600',
        nm: '那曲市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '542500',
        nm: '阿里地区',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '610000',
    nm: '陕西省',
    nodeLvl: 1,
    children: [
      {
        cd: '610100',
        nm: '西安市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '610200',
        nm: '铜川市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '610300',
        nm: '宝鸡市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '610400',
        nm: '咸阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '610500',
        nm: '渭南市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '610600',
        nm: '延安市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '610700',
        nm: '汉中市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '610800',
        nm: '榆林市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '610900',
        nm: '安康市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '611000',
        nm: '商洛市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '620000',
    nm: '甘肃省',
    nodeLvl: 1,
    children: [
      {
        cd: '620100',
        nm: '兰州市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '620200',
        nm: '嘉峪关市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '620300',
        nm: '金昌市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '620400',
        nm: '白银市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '620500',
        nm: '天水市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '620600',
        nm: '武威市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '620700',
        nm: '张掖市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '620800',
        nm: '平凉市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '620900',
        nm: '酒泉市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '621000',
        nm: '庆阳市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '621100',
        nm: '定西市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '621200',
        nm: '陇南市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '622900',
        nm: '临夏回族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '623000',
        nm: '甘南藏族自治州',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '630000',
    nm: '青海省',
    nodeLvl: 1,
    children: [
      {
        cd: '630100',
        nm: '西宁市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '630200',
        nm: '海东市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '632200',
        nm: '海北藏族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '632300',
        nm: '黄南藏族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '632500',
        nm: '海南藏族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '632600',
        nm: '果洛藏族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '632700',
        nm: '玉树藏族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '632800',
        nm: '海西蒙古族藏族自治州',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '640000',
    nm: '宁夏回族自治区',
    nodeLvl: 1,
    children: [
      {
        cd: '640100',
        nm: '银川市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '640200',
        nm: '石嘴山市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '640300',
        nm: '吴忠市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '640400',
        nm: '固原市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '640500',
        nm: '中卫市',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '650000',
    nm: '新疆维吾尔自治区',
    nodeLvl: 1,
    children: [
      {
        cd: '650100',
        nm: '乌鲁木齐市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '650200',
        nm: '克拉玛依市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '650400',
        nm: '吐鲁番市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '650500',
        nm: '哈密市',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '652300',
        nm: '昌吉回族自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '652700',
        nm: '博尔塔拉蒙古自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '652800',
        nm: '巴音郭楞蒙古自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '652900',
        nm: '阿克苏地区',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '653000',
        nm: '克孜勒苏柯尔克孜自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '653100',
        nm: '喀什地区',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '653200',
        nm: '和田地区',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '654000',
        nm: '伊犁哈萨克自治州',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '654200',
        nm: '塔城地区',
        nodeLvl: 2,
        children: []
      },
      {
        cd: '654300',
        nm: '阿勒泰地区',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '710000',
    nm: '台湾省',
    nodeLvl: 1,
    children: [
      {
        cd: '710100',
        nm: '台湾省',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '810000',
    nm: '香港特别行政区',
    nodeLvl: 1,
    children: [
      {
        cd: '810100',
        nm: '香港特别行政区',
        nodeLvl: 2,
        children: []
      }
    ]
  },
  {
    cd: '820000',
    nm: '澳门特别行政区',
    nodeLvl: 1,
    children: [
      {
        cd: '820100',
        nm: '澳门特别行政区',
        nodeLvl: 2,
        children: []
      }
    ]
  }
]
